import { Button, Col, Flex, Form, message, Row, Space, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { APP_TERMS } from '../../../app-terms';
import { useUserLocale } from '../../../hooks/useLocale';
import { useState } from 'react';
import { mapRadiologistInvoiceServicesToPayload } from '../../../utils/invoice';
import { logoVoxel } from '../../imagepath';
import BasicCard from '../../core/Cards/BasicCard';
import { formatDate } from '../../../utils/date';
import EditRadiologistInvoiceService from '../../invoices/EditRadiologistInvoiceService';
import { useRadiologistInvoiceUpdate } from '../../../hooks/radiologists/useRadiologistInvoiceUpdate';

const { Paragraph, Title, Text } = Typography;

const RadiologistInvoiceForm = ({ data }) => {
  const navigate = useNavigate();
  const { userLocale } = useUserLocale();
  const [invoiceDetails, setInvoiceDetails] = useState(data);
  const { loading, updateInvoice } = useRadiologistInvoiceUpdate();
  const [form] = Form.useForm();

  const handleSave = async () => {
    // Call api to enable the clinic
    try {
      const formData = form.getFieldsValue();
      const isInvalid =
        formData?.invoiceCaseServices?.filter((service) => {
          return !service?.amount;
        })?.length > 0;
      if (isInvalid) return;

      await updateInvoice({
        invoiceCaseServices: mapRadiologistInvoiceServicesToPayload(
          formData?.invoiceCaseServices
        ),
      });
      message.success('Invoice updated successfully');
      navigate(-1);
    } catch (error) {
      console.log('error on save: ', error);
    }
  };

  const handleServicesChange = (services) => {
    setInvoiceDetails((prev) => ({
      ...prev,
      invoiceCaseServices: services,
    }));
  };

  return (
    <Form form={form} initialValues={invoiceDetails} layout="vertical">
      <Row gutter={[16, 16]} className="mt-3">
        <Col span={24}>
          <Flex justify="space-between">
            <img src={logoVoxel} alt="#" style={{ height: 80 }} />
            <Flex vertical justify="end" align="end">
              <Title level={5}>Voxel Readers</Title>
              <Text>15340 Larsen Street</Text>
              <Text>Overland Park Kansas 66221</Text>
              <Text>
                <Text strong>Call:</Text> +1 913-308-8994
              </Text>
              <Text>
                <Text strong>Email:</Text> info@voxelreaders.com
              </Text>
            </Flex>
          </Flex>
        </Col>
        <Col sm={24} md={12}>
          <BasicCard
            size="small"
            style={{ height: '100%' }}
            title={APP_TERMS.generic_to}
          >
            <Paragraph>{invoiceDetails?.radiologistName}</Paragraph>
            <Paragraph>{invoiceDetails?.radiologistEmail}</Paragraph>
          </BasicCard>
        </Col>
        <Col sm={24} md={12}>
          <BasicCard
            size="small"
            style={{ height: '100%' }}
            title={`${APP_TERMS.generic_invoice} ${APP_TERMS.generic_details}`}
          >
            <Paragraph>{invoiceDetails?.invoiceNo}</Paragraph>
            <Paragraph>
              {invoiceDetails?.createdAt &&
                formatDate(
                  invoiceDetails?.createdAt,
                  APP_TERMS.date_1_format,
                  userLocale
                )}
            </Paragraph>
          </BasicCard>
        </Col>
        <Col span={24}>
          <Form.Item name="invoiceCaseServices">
            <EditRadiologistInvoiceService
              initialData={invoiceDetails?.invoiceCaseServices}
              onChange={handleServicesChange}
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item className="mt-3">
        <Space>
          <Button
            key="enable"
            type="primary"
            htmlType="button"
            loading={loading}
            onClick={handleSave}
          >
            Save
          </Button>
          <Button
            htmlType="button"
            disabled={loading}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};
RadiologistInvoiceForm.propTypes = {
  data: PropTypes.object,
};
export default RadiologistInvoiceForm;
